export const steps = [
    // Home Buying
    { step: 1, route: '/apply-now' },
    { step: 2, route: '/home-buying' },
    { step: 3, route: '/home-buying/getting-started' },
    { step: 4, route: '/home-buying/get-prequalified' },
    { step: 5, route: '/home-buying/making-offers' },
    { step: 6, route: '/home-buying/signed-agreement' },
    { step: 7, route: '/home-buying/connected-with-ae' },
    { step: 8, route: '/home-buying/who-is-ae' },
    { step: 9, route: '/home-buying/found-home' },
    { step: 10, route: '/home-buying/home-location' },
    { step: 11, route: '/home-buying/what-type-home-is' },
    { step: 12, route: '/home-buying/how-plan-to-use-it' },
    { step: 13, route: '/home-buying/property-taxes' },
    { step: 14, route: '/home-buying/seller-concessions' },
    { step: 15, route: '/home-buying/earnest-money-deposit' },
    { step: 16, route: '/home-buying/expected-closing-date' },
    { step: 17, route: '/home-buying/picked-home-price' },
    { step: 18, route: '/home-buying/first-time-homebuyer' },
    { step: 19, route: '/home-buying/estimated-down-payment' },
    { step: 20, route: '/home-buying/down-payment-assistance' },
    { step: 21, route: '/home-buying/working-with-real-estate-agent' },
    { step: 22, route: '/home-buying/agent-contact-info' },
    { step: 23, route: '/home-buying/buying-with-guidance' },
    { step: 24, route: '/home-buying/own-or-rent' },
    { step: 25, route: '/home-buying/your-current-address' },
    { step: 26, route: '/home-buying/plan-to-sell' },
    { step: 27, route: '/home-buying/estimated-selling-price' },
    { step: 28, route: '/home-buying/current-mortgage-balance' },
    { step: 29, route: '/home-buying/monthly-mortgage-payment' },
    { step: 30, route: '/home-buying/selling-with-guidance' },
    { step: 31, route: '/home-buying/personal-info' },
    { step: 32, route: '/home-buying/your-info' },
    { step: 33, route: '/home-buying/co-applicant' },
    { step: 34, route: '/home-buying/coapplicant' },
    { step: 35, route: '/home-buying/coapplicant-contact-info' },
    { step: 36, route: '/home-buying/your-credit-score' },
    { step: 37, route: '/home-buying/employment-status' },
    { step: 38, route: '/home-buying/bankruptcy' },
    { step: 39, route: '/home-buying/finances' },
    { step: 40, route: '/home-buying/yearly-income' },
    { step: 41, route: '/home-buying/coapplicant-annual-income' },
    { step: 42, route: '/home-buying/list-your-expenses' },
    { step: 43, route: '/home-buying/create-account' },
    { step: 44, route: '/home-buying/new-account' },
    { step: 45, route: '/home-buying/success' },
    { step: 46, route: '/home-buying/need-more-info' },

    // Home Buy/Sell
    { step: 48, route: '/home-buy-sell' },
    { step: 49, route: '/home-buy-sell/where-home-buying-journey' },
    { step: 50, route: '/home-buy-sell/when-to-buy-home' },
    { step: 51, route: '/home-buy-sell/get-prequalified' },
    { step: 52, route: '/home-buy-sell/making-offers-get-prequalified' },
    { step: 53, route: '/home-buy-sell/signed-agreement-get-prequalified' },
    { step: 54, route: '/home-buy-sell/connected-with-ae' },
    { step: 55, route: '/home-buy-sell/who-is-ae' },
    { step: 56, route: '/home-buy-sell/found-home' },
    { step: 57, route: '/home-buy-sell/home-location' },
    { step: 58, route: '/home-buy-sell/what-type-home-is' },
    { step: 59, route: '/home-buy-sell/how-plan-to-use-it' },
    { step: 60, route: '/home-buy-sell/property-taxes' },
    { step: 61, route: '/home-buy-sell/seller-concessions' },
    { step: 62, route: '/home-buy-sell/earnest-money-deposit' },
    { step: 63, route: '/home-buy-sell/expected-closing-date' },
    { step: 64, route: '/home-buy-sell/picked-home-price' },
    { step: 65, route: '/home-buy-sell/first-time-homebuyer' },
    { step: 66, route: '/home-buy-sell/estimated-down-payment' },
    { step: 67, route: '/home-buy-sell/down-payment-assistance' },
    { step: 68, route: '/home-buy-sell/working-with-real-estate-agent' },
    { step: 69, route: '/home-buy-sell/agent-contact-info' },
    { step: 70, route: '/home-buy-sell/buying-with-guidance' },
    { step: 71, route: '/home-buy-sell/own-or-rent' },
    { step: 72, route: '/home-buy-sell/your-current-address' },
    { step: 73, route: '/home-buy-sell/plan-to-sell' },
    { step: 74, route: '/home-buy-sell/estimated-selling-price' },
    { step: 75, route: '/home-buy-sell/current-mortgage-balance' },
    { step: 76, route: '/home-buy-sell/monthly-mortgage-payment' },
    { step: 77, route: '/home-buy-sell/selling-with-guidance' },
    { step: 78, route: '/home-buy-sell/personal-info' },
    { step: 79, route: '/home-buy-sell/your-info' },
    { step: 80, route: '/home-buy-sell/co-applicant' },
    { step: 81, route: '/home-buy-sell/coapplicant' },
    { step: 82, route: '/home-buy-sell/coapplicant-contact-info' },
    { step: 83, route: '/home-buy-sell/your-credit-score' },
    { step: 84, route: '/home-buy-sell/employment-status' },
    { step: 85, route: '/home-buy-sell/bankruptcy' },
    { step: 86, route: '/home-buy-sell/finances' },
    { step: 87, route: '/home-buy-sell/yearly-income' },
    { step: 88, route: '/home-buy-sell/coapplicant-annual-income' },
    { step: 89, route: '/home-buy-sell/list-your-expenses' },
    { step: 90, route: '/home-buy-sell/create-account' },
    { step: 91, route: '/home-buy-sell/new-account' },
    { step: 92, route: '/home-buy-sell/success' },
    { step: 93, route: '/home-buy-sell/need-more-info' },

    // Home Sell
    { step: 95, route: '/home-sell' },
    { step: 96, route: '/home-sell/save' },
    { step: 97, route: '/home-sell/feedback' },

    { step: 98, route: '/refinance' },
    { step: 99, route: '/refinance/goals' },
    { step: 100, route: '/refinance/how-plan-to-use-cash' },
    { step: 101, route: '/refinance/personal-info' },
    { step: 102, route: '/refinance/connected-with-ae' },
    { step: 103, route: '/refinance/who-is-ae' },
    { step: 104, route: '/refinance/your-info' },
    { step: 105, route: '/refinance/co-applicant' },
    { step: 106, route: '/refinance/coapplicant' },
    { step: 107, route: '/refinance/coapplicant-contact-info' },
    { step: 108, route: '/refinance/your-credit-score' },
    { step: 109, route: '/refinance/employment-status' },
    { step: 110, route: '/refinance/bankruptcy' },
    { step: 111, route: '/refinance/home-info' },
    { step: 112, route: '/refinance/your-home-address' },
    { step: 113, route: '/refinance/estimated-home-value' },
    { step: 114, route: '/refinance/current-mortgage-balance' },
    { step: 115, route: '/refinance/how-much-cash' },
    { step: 116, route: '/refinance/what-type-home-is' },
    { step: 117, route: '/refinance/how-plan-to-use-it' },
    { step: 118, route: '/refinance/pay-hoa' },
    { step: 119, route: '/refinance/included-in-mortgage-payments' },
    { step: 120, route: '/refinance/property-taxes' },
    { step: 121, route: '/refinance/finances' },
    { step: 122, route: '/refinance/yearly-income' },
    { step: 123, route: '/refinance/coapplicant-annual-income' },
    { step: 124, route: '/refinance/list-your-expenses' },
    { step: 125, route: '/refinance/create-account' },
    { step: 126, route: '/refinance/new-account' },
    { step: 127, route: '/refinance/success' },
    { step: 128, route: '/refinance/need-more-info' }

    // Add more steps as needed
];

export const findStepByRoute = (workflow_route) => {
    return steps.find((step) => step.route === workflow_route);
};

export const findRouteByStep = (workflow_step) => {
    return steps.find((step) => step.step === workflow_step);
};

export const findFinalPageRoute = (workflow, approved) => {
    const workflows = {
        1: '/home-buying/',
        2: '/home-buy-sell/',
        4: '/refinance/'
    };

    const finalPage = approved ? 'success' : 'need-more-info';

    if (workflow === 3) {
        return '/home-sell/feedback';
    }

    return workflows[workflow] + finalPage;
};

export const findPageByWorkflow = (workflow, page) => {
    const workflows = {
        1: '/home-buying/',
        2: '/home-buy-sell/',
        4: '/refinance/'
    };

    return workflows[workflow] + page;
};

export const convertRouteToNavigable = (workflow_step, approved) => {
    const route = findRouteByStep(parseInt(workflow_step) + 1);
    const parts = route?.route?.split('/').filter(Boolean);

    const isFinalStep = parts.includes('create-account') || parts.includes('success');
    const finalPage = approved ? 'success' : 'need-more-info';

    if (isFinalStep) {
        return `${parts[0]}.${finalPage}`;
    }

    return parts.join('.');
};

export const hasUserDataSubmission = (step) => {
    const stepsWithUserData = [32, 79, 96, 104];

    return stepsWithUserData.includes(step);
};
